/**
 * @desc 通过SupplierName获取供应商信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/getBySupplierName`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
